/**
 * 运行时环境配置
 * - 所有读取 import.meta.env 的逻辑统一收口于此
 * - 业务代码应只 import 本模块导出的常量，禁止直接读 import.meta.env
 */

export const APP_ENV = import.meta.env.VITE_APP_ENV
export const APP_TITLE = import.meta.env.VITE_APP_TITLE
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || ''
export const UPLOAD_URL = import.meta.env.VITE_UPLOAD_URL || ''
export const CDN_URL = import.meta.env.VITE_CDN_URL || ''
export const QUOTES_WS_ENABLED = import.meta.env.VITE_QUOTES_WS_ENABLED !== 'false'
export const QUOTES_TRANSPORT = (import.meta.env.VITE_QUOTES_TRANSPORT || 'auto') as 'auto' | 'ws' | 'sse' | 'poll'
/** Aliyun poll 默认 15s，避免打满后端小时/分钟限流 */
export const QUOTES_POLL_MS = Math.max(
  5000,
  Number(import.meta.env.VITE_QUOTES_POLL_MS || 15_000) || 15_000,
)

export const IS_DEV = APP_ENV === 'development'
export const IS_PROD = APP_ENV === 'production'
